import { combineReducers } from 'redux'
import {
  createReducer,
} from 'helpers/ReducerUtil'
import {
  FILTER_ALL,
  SELECT_FILTER,
} from './constants'

const selectFilter = (values, action) => action.filter

const selectFilterReducer = createReducer(FILTER_ALL, {
  [SELECT_FILTER]: selectFilter,
})

export const filterUiReducer = combineReducers({
  curFilter: selectFilterReducer,
})
